module.exports = __webpack_public_path__ + "static/media/loader.56ddaefb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/loader.svg
// module id = 433
// module chunks = 0